<template>
  <div class="form-certification">
    <edit-table
      :option="option"
      :data="data"
      :form.sync="form"
      :loading="loading"
      @submit-add="handleSubmit"
      @submit-edit="handleUpdate"
      @refresh-change="refreshChange"
      @rowDel="handleRowDel"
    >
      <!-- <template
        slot="row-details"
        slot-scope="{row}"
      >
        <div style="display:flex;justify-content: space-between;margin-right:200px;">
          <span
            v-for="(item, i) in option.columns"
            :key="i"
          >
            {{ updateAuditData[row.item.id][(item.dictField ? item.dictField : item.field)] }}
          </span>
        </div>
      </template> -->
    </edit-table>
  </div>
</template>

<script>
import EditTable from '@/components/editTable/index.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { expensePercentage } from '@/api/staff/index';
import { deepClone } from '@/util/util'
import getColumn from './option/expensePercentage'

export default {
  components: {
    EditTable,
  },
  props: {
    // data: {
    //   type: Array,
    //   default: () => [],
    // },
    staffId: {
      type: String,
      default: '',
    },
    auditData: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    currentTab: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      redata: [],
      loading: false,
      // 需要number转string的类型
      hasToStringTypes: ['select'],
      form: { relation: null },
      // data: [
      //   {
      //     relation: 'Activity Tracker',
      //     name: 'wangsan',
      //     sex: '1',
      //     nationality: '2',
      //     mobile: '132145124',
      //     email: '123123@qq.com',
      //     adderss: 'wuhan',
      //   },
      // ],
      updateAuditData: {},
      dictType: {
        4: 'Allocation department',
        3: 'Project',
        2: 'Property project',
        1: 'Property project',
      },
      numberMax: 1,
    }
  },
  computed: {
    option() {
      const option = {
        drawer: true,
        menu: !this.disabled,
        addBtn: !this.disabled,
        columns: getColumn(this.form, this.numberMax),
      }
      return option
    },
  },
  watch: {
    currentTab(e) {
      if (e === 10) {
        this.onLoad()
      }
    },
    'form.type': {
      handler(e, o) {
        if (String(e) !== String(o) && o) {
          delete this.form.projectOrDeptId
        }
      },
      deep: true,
    },
    'form.projectOrDeptId': {
      handler(e, o) {
        if (String(e) !== String(o) && o) {
          delete this.form.positionId
        }
      },
      deep: true,
    },
  },
  mounted() {
    // this.redata = this.data
  },
  methods: {
    async onLoad() {
      this.loading = true
      //   const res2 = await infoAudit.getList(1, -1, { staffId: this.staffId, status: 1, module: 'infoFamilies' })
      //   this.reauditData = res2.data.data.records
      const res = await expensePercentage.getList(1, -1, { staffId: this.staffId })
      const data = []
      const t = res.data.data || []
      let sum = 0
      t.forEach(item => {
        const p = item
        p.typeName = this.dictType[item.type]
        sum += Number(p.expense)
        data.push(p)
      });
      this.numberMax = sum > 1 ? 0 : 1 - sum
      this.data = data
      this.loading = false
    },
    // 国际化
    i18n(param) {
      return this.$t(`_staff.labelFamily.${param}`)
    },
    handleSubmit(done, row = {}) {
      const params = row
      params.staffId = this.staffId
      //   let type;
      //   Object.keys(this.dictType).forEach(key => {
      //     const element = this.dictType[key];
      //     if (row.type === element) {
      //       type = key
      //     }
      //   })
      //   params.type = type
      expensePercentage.add(params).then(async () => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        await this.onLoad()
        done()
      }).catch(err => {
        done()
      });
    },
    handleUpdate(done, row = {}) {
      const params = row
      Object.keys(params).forEach(key => {
        const element = params[key];
        if (!element) {
          delete params[key]
        }
      })
      expensePercentage.update(params).then(async () => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        await this.onLoad()
        done()
      }).catch(err => {
        done()
      });
    },
    handleRowDel(done, row) {
      expensePercentage.remove({ id: row.id, type: row.type }).then(async () => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        await this.onLoad()
        done()
      }).catch(err => {
        done()
      });
    },
    refreshChange() {
      this.onLoad()
    },
  },
}
</script>
<style lang="scss">
.form-certification{
  &-top{
    text-align: right;
  }
  .table-td{
    text-align: center;
    line-height: 50px;
    &-sm{
      width: 200px;
    }
  }
}
</style>
